<template>
  <div>
    <TableWrapper
      :table-columns="signatureRecipientsColumns"
      table-key="signatureRecipients"
      :enable-selection="false"
      @editRecipientGroup="goToEdit"
      @deleteRecipientGroup="deleteRecipientGroup"
    />

    <ViewActionButtons :buttons="actionButtons" />

    <CreateEditRecipient
      v-if="openCreateEditRecipient"
      :is-modal-edit="isModalEdit"
      :initial-data="initialRecipientData"
      @dialogClose="handleDialogClose"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import TableWrapper from '@/components/TableWrapper.vue';
  import ViewActionButtons from '@/components/ViewActionButtons.vue';
  import { signatureRecipientsColumns } from '@/config';
  import { recipientGroupsApi } from '@/api';
  import CreateEditRecipient from './CreateEditRecipient.vue';

  export default {
    name: 'RolesIndex',
    components: {
      TableWrapper,
      ViewActionButtons,
      CreateEditRecipient,
    },
    data() {
      return {
        signatureRecipientsColumns,
        openCreateEditRecipient: false,
        isModalEdit: false,
        initialRecipientData: {},
        actionButtons: [
          {
            text: this.$t('recipients.create.createRecipient'),
            type: 'primary',
            action: () => {
              this.openCreateEditRecipient = true;
            },
          },
        ],
      };
    },
    computed: {
      ...mapGetters(['tableFilters']),
    },
    created() {
      this.tableRows();
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        if (to.params.recipientGroupId) vm.getRecipientGroup();
      });
    },
    beforeRouteUpdate(to, from, next) {
      this.tableRows();
      next();
    },
    methods: {
      ...mapActions(['updateTableRows', 'updateTableCount']),
      async tableRows() {
        try {
          const recipientGroupsIndex = await recipientGroupsApi.index(
            this.tableFilters('signatureRecipients')
          );
          const recipientGroupsCount = await recipientGroupsApi.count();
          this.updateTableRows({
            tableKey: 'signatureRecipients',
            rows: recipientGroupsIndex.data,
          });
          this.updateTableCount({
            tableKey: 'signatureRecipients',
            count: recipientGroupsCount.data.count,
          });
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
      async getRecipientGroup() {
        try {
          const recipientGroup = await recipientGroupsApi.show(
            this.$route.params.recipientGroupId
          );
          this.initialRecipientData = { ...recipientGroup.data };
          this.isModalEdit = true;
          this.openCreateEditRecipient = true;
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
          this.$router.push({ name: 'signatureRecipientsIndex' });
        }
      },
      goToEdit(row) {
        this.$router.push({
          name: 'signatureRecipientsEdit',
          params: { recipientGroupId: row.id },
        });
      },
      deleteRecipientGroup(row) {
        this.$confirm(
          this.$t('recipients.delete.message'),
          this.$t('recipients.delete.title'),
          {
            confirmButtonText: this.$t('global.confirm'),
            cancelButtonText: this.$t('global.cancel'),
            type: 'warning',
          }
        )
          .then(() => recipientGroupsApi.deleteGroup(row.id))
          .then(() => {
            this.$notify({
              showClose: true,
              type: 'success',
              message: this.$t('recipients.delete.success'),
            });
            this.tableRows();
          })
          .catch((error) => {
            if (error.response) {
              this.$notify({
                showClose: true,
                type: 'error',
                message: error.response.data.error.message,
              });
            }
          });
      },
      handleDialogClose(status) {
        this.openCreateEditRecipient = false;
        if (status.success) this.tableRows();
        if (this.isModalEdit) {
          this.isModalEdit = false;
          this.$router.push({ name: 'signatureRecipientsIndex' });
        }
      },
    },
  };
</script>
